import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Alert, Button, Col, Collapse, Glyphicon, PageHeader, Row, Well } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import DefaultRoutes from '../../routes/DefaultRoutes';
import { InjectedProps } from '../../types';
import { Regions } from '../../types/Regions';
import RegionsNew from './RegionsNew';

interface RegionsListState {
    open: boolean;
    newItem?: Regions;
    sortName: any;
    sortOrder: any;
}

@inject('store')
@observer
export class RegionsList extends React.Component<{}, RegionsListState> {
    public get injected() {
        return this.props as InjectedProps;
    }

    public state: RegionsListState = {
        open: false,
        sortName: 'name',
        sortOrder: 'asc'
    };

    public componentDidMount() {
        const { fetchRegions } = this.injected.store;
        return fetchRegions();
    }

    public onSortChange(sortName: any, sortOrder: any) {
        this.setState({
            sortName,
            sortOrder
        });
    }

    public render() {
        const { newItem } = this.state;
        const options = {
            onRowClick: this.handleRowClick,
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
            onSortChange: this.onSortChange
        };
        const { regions } = this.injected.store;

        return (
            <>
                <PageHeader>Regions</PageHeader>
                <Col className="col-lg-12">
                    {newItem && (
                        <Alert bsStyle="success" onDismiss={this.handleDismissAlert}>
                            New Region "{newItem.name}" was created successfully.
                        </Alert>
                    )}
                    <Row>
                        <Button bsStyle="primary" onClick={this.toggleNewForm}>
                            Create Region <Glyphicon glyph="plus" />
                        </Button>
                    </Row>
                    <Collapse in={this.state.open}>
                        <Row>
                            <Well>
                                <RegionsNew handleClose={this.itemAdded} />
                            </Well>
                        </Row>
                    </Collapse>
                    <Row>
                        <BootstrapTable data={regions.values} options={options} pagination search striped>
                            <TableHeaderColumn dataField="id" isKey width="80" dataSort>
                                ID
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="name" dataSort>
                                Name
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </Row>
                </Col>
            </>
        );
    }

    public handleRowClick = (row: any) => {
        const { router } = this.injected.store;
        router.goTo(DefaultRoutes.RegionsEdit, { id: row.id }, this.injected.store);
    };

    public toggleNewForm = () => {
        this.setState({ open: !this.state.open });
    };

    public itemAdded = (item: any) => {
        this.setState({ newItem: item });
        this.toggleNewForm();
    };

    public handleDismissAlert = () => {
        this.setState({ newItem: undefined });
    };
}

export default RegionsList;
